import { render, staticRenderFns } from "./process_a.vue?vue&type=template&id=5bd77c20&scoped=true"
import script from "./process_a.vue?vue&type=script&lang=js"
export * from "./process_a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd77c20",
  null
  
)

export default component.exports